module.exports = __webpack_public_path__ + "img/instagram-icon.db782b47.svg";